import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { use_component_action_button_auth_with_email_and_password } from '../_hooks/use_component_action_button_auth_with_email_and_password';
import { WatcherShortcutAuthWithEmailAndPassword } from '../_watchers/watcher_shortcut_auth_with_email_and_password';

interface Props {
  email: string;
  password: string;
}

export const A_BUTTON__auth_email_and_password = React.forwardRef<HTMLButtonElement, Props>(({ email, password }, ref) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  const { can_try_auth_with_email_and_password, auth_with_email_and_password } = use_component_action_button_auth_with_email_and_password(email, password);

  /*
   * EVENTS
   */

  return (
    <>
      <WatcherShortcutAuthWithEmailAndPassword {...{ email, password }} />
      <UI_PRIMITIVE__button
        variant="outline-on-component"
        className="w-full text-bar-foreground"
        disabled={!can_try_auth_with_email_and_password}
        onClick={() => auth_with_email_and_password()}
        ref={ref}
      >
        {t(i18n_page_auth.auth_component.button.get_started_with_password)}
      </UI_PRIMITIVE__button>
    </>
  );
});
